/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SearchUnmatchedChainsQueryResponse,
  SearchUnmatchedChainsQueryParams,
} from '../types/SearchUnmatchedChains'

function getSearchUnmatchedChainsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/common/search/chains_unmatched/` as const,
  }
  return res
}

/**
 * @description Handle GET request for search.
 * This is the main entry point that orchestrates the search process.
 * @summary Search the tenant's custom (unmatched) companies
 * {@link /api/v1/common/search/chains_unmatched/}
 */
export async function searchUnmatchedChains(
  params: SearchUnmatchedChainsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SearchUnmatchedChainsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getSearchUnmatchedChainsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
